import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";

function AdminRegister() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [name, setName] = useState("");

    const navigate = useNavigate();

    const handleRegister = async (e) => {
        e.preventDefault();

        try {
            await API.post("/api/admin/register", {
                name,
                email,
                password
            })

            alert("Admin Registered")
            navigate("/admin/login")
        } catch (error) {
            console.log(error)
        }
    };

    return (
        <div className="container mt-5">

            <h2>Admin Register</h2>

            <form onSubmit={handleRegister}>

                <input
                    className="form-control mb-3"
                    placeholder="Name"
                    onChange={(e) => setName(e.target.value)}
                />

                <input
                    className="form-control mb-3"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                />

                <input
                    type="password"
                    className="form-control mb-3"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                />

                <button className="btn btn-dark">
                    Register
                </button>

            </form>

        </div>
    )

}

export default AdminRegister;